import { Clock } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";

const translations = {
  en: { cta: "Start the timer" },
  fr: { cta: "Lancer le chrono" }
};

interface CTAButtonProps {
  onClick?: () => void;
  className?: string;
}

const CTAButton = ({
  onClick,
  className = ""
}: CTAButtonProps) => {
  const shouldReduceMotion = useReducedMotion();
  const { lang } = useLanguage();
  const t = translations[lang];

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      const ctaSection = document.getElementById('contact');
      if (ctaSection) {
        ctaSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <motion.button
      onClick={handleClick}
      className={`relative group ${className}`}
      whileHover={{
        scale: shouldReduceMotion ? 1 : 1.02
      }}
      whileTap={{
        scale: shouldReduceMotion ? 1 : 0.98
      }}
    >
      {/* Hover glow effect - Cyan blue like the reference image */}
      <div
        className="absolute -inset-6 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        style={{
          background: `radial-gradient(ellipse at center, hsl(190 100% 50% / 0.8), hsl(200 100% 60% / 0.5), transparent 70%)`
        }}
      />
      <div
        className="absolute -inset-8 rounded-full blur-2xl opacity-0 group-hover:opacity-60 transition-opacity duration-500"
        style={{
          background: `radial-gradient(ellipse at center, hsl(190 100% 50% / 0.5), transparent 60%)`
        }}
      />

      {/* Button content */}
      <div className="relative bg-surface rounded-full py-4 gap-3 transition-all duration-300 items-center justify-center text-white px-[33px] flex flex-row">
        <span className="font-bold text-lg tracking-wide text-foreground">
          {t.cta}
        </span>
        <Clock strokeWidth={2.5} className="w-5 h-5 text-primary" />
      </div>
    </motion.button>
  );
};

export default CTAButton;